export type AppConfig = {
    sso: {
        domain: string
        clientId: string
        customClaims: string
    }
    ftsClientBaseUrlAi: string
    jarvisBaseUrl: string
    heimdallBaseUrl: string
    luigiApiBaseUrl: string
    expertsApiBaseUrl: string
    mistralApiBaseUrl: string
    editorConfig: {
        apiKey: string
        isReadabilityEnabled: boolean
        isSensitivityEnabled: boolean
        isGrammarEnabled: boolean
    }
    gamId?: string
    amplitudeAPIKey: string
    buildEnvironment: string
    envFtsPrivateStaticAssetsDistributionUrl: string
    ftsConsoleUrl: string
}

const buildEnvironment: string = process.env.ENV_BUILD_ENVIRONMENT!

export const appConfig: AppConfig = {
    sso: {
        domain: buildEnvironment == 'playdock' ? `$ENV_SSO_DOMAIN` : process.env.ENV_SSO_DOMAIN!,
        clientId: process.env.ENV_SSO_CLIENT_ID!,
        customClaims:
            buildEnvironment == 'playdock'
                ? `$ENV_SSO_CUSTOM_CLAIMS`
                : process.env.ENV_SSO_CUSTOM_CLAIMS!,
    },
    luigiApiBaseUrl:
        buildEnvironment == 'playdock' ? `$ENV_LUIGI_BASE_URL` : process.env.ENV_LUIGI_BASE_URL!,
    buildEnvironment,
    ftsClientBaseUrlAi:
        buildEnvironment == 'playdock'
            ? `$ENV_FTS_CLIENT_BASE_URL_AI`
            : process.env.ENV_FTS_CLIENT_BASE_URL_AI!,
    jarvisBaseUrl:
        buildEnvironment == 'playdock' ? `$ENV_JARVIS_BASE_URL` : process.env.ENV_JARVIS_BASE_URL!,
    heimdallBaseUrl:
        buildEnvironment == 'playdock'
            ? `$ENV_HEIMDALL_BASE_URL`
            : process.env.ENV_HEIMDALL_BASE_URL!,
    expertsApiBaseUrl:
        buildEnvironment == 'playdock'
            ? `$ENV_EXPERTS_API_BASE_URL`
            : process.env.ENV_EXPERTS_API_BASE_URL!,
    mistralApiBaseUrl:
        buildEnvironment == 'playdock'
            ? `$ENV_MISTRAL_API_BASE_URL`
            : process.env.ENV_MISTRAL_API_BASE_URL!,
    editorConfig: {
        apiKey: process.env.ENV_TINYMCE_API_KEY!,
        isReadabilityEnabled: process.env.ENV_IS_READABILITY_ENABLED === 'true',
        isSensitivityEnabled: process.env.ENV_IS_SENSITIVITY_ENABLED === 'true',
        isGrammarEnabled: process.env.ENV_IS_GRAMMAR_ENABLED === 'true',
    },
    envFtsPrivateStaticAssetsDistributionUrl:
        process.env.ENV_FTS_PRIVATE_STATIC_ASSETS_BUCKET_DISTRIBUTION_URL!,
    gamId: buildEnvironment == 'playdock' ? `$ENV_TRACKER_ID` : process.env.ENV_TRACKER_ID!,
    amplitudeAPIKey: process.env.ENV_AMPLITUDE_API_KEY!,
    ftsConsoleUrl:
        buildEnvironment == 'playdock' ? `$ENV_FTS_CONSOLE_URL` : process.env.ENV_FTS_CONSOLE_URL!,
}
